import React, { useState } from 'react'
import { Button, Dialog, IconButton, Snackbar } from '@mui/material'
import MuiAlert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import useCreate from '../../hooks/useCreate';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function DeleteBrand({ open, onClose, id, onDelete }) {
    const [error, setError] = useState({ show: false, message: "" });
    
    const { setDataToServer: setDeleteBrand } = useCreate({
        refreshUrl: 'getBrandList',
        url: 'deleteBrand',
        onSuccess: () => {
            onDelete();
        },
        onError: (error) => {
            setError({ 
                show: true, 
                message: error?.response?.data?.message || "Error deleting brand"
            });
        }
    });

    const handleDeleteBrand = (e) => {
        e.preventDefault();
        setDeleteBrand.mutate({
            brand_id: id
        });
    }

    const handleCloseError = () => {
        setError({ show: false, message: "" });
    }

    return (
        <>
            <Dialog fullWidth={true} maxWidth={'sm'} open={open} onClose={onClose}>
                <div className=' bg-white w-full px-5'>
                    <div className='modal-head flex items-center justify-end'>
                        <div onClick={onClose}>
                            <IconButton>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div>
                    <form className=' space-y-4' onSubmit={handleDeleteBrand}>
                        <div className=' space-y-7'>
                            <div>
                                <h1 className=' text-2xl text-red-700 font-semibold text-center'>Are You Sure You Want To Delete?</h1>
                            </div>
                        </div>
                        <div className=' space-x-4 text-center pb-5'>
                            <Button type='submit' variant="contained" color={`error`}>Delete</Button>
                            <Button variant="outlined" color='info' onClick={onClose}>Close</Button>
                        </div>
                    </form>
                </div>
            </Dialog>
            <Snackbar open={error.show} autoHideDuration={4000} onClose={handleCloseError}>
                <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                    {error.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default DeleteBrand
